<template>
  <div class="c-app flex-row align-items-center">
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody class="login-form-left">
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="User ID"
                    autocomplete="userId"
                    name="userId"
                    value=""
                    type="number"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    name="password"
                    value=""
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        @click="viewMenuDash()"
                        >Login</CButton
                      >
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0" @click="viewForgot()"
                        >Forgot password?</CButton
                      >
                      <CButton color="link" class="d-lg-none"
                        >Register now!</CButton
                      >
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol col="12" class="text-left">
                      <p style="color: red" id="reponse_error"></p>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <!-- <h2 class="m-0" style="color: #3c4b64;">Sign up</h2> -->
                <!-- <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua.
                </p> -->
                <img src="img/luthrahorse.png" class="c-avatar-img" />
                <!-- <CButton color="white" variant="outline" size="lg" @click="viewMenu()" style="color: #3c4b64;border-color: #3c4b64;">
                  Register Now!
                </CButton> -->
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      menuName: this.$route.MenuName,
      title: "login",
      isLoading: false,
    };
  },
  mounted() {
    /*localStorage.setItem("auth","eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJWaW5lc2hBY2Nlc3NUb2tlbiIsImp0aSI6ImQ2MTk1ODA0LTNiYzQtNDI4Yy1hZTAzLTJiMzEwOWQ1Y2JlOSIsImlhdCI6IjEyLzI4LzIwMjAgMTE6MjI6NTAgQU0iLCJJZCI6IjQxMDAwMDIyNjUiLCJGaXJzdE5hbWUiOiJTUkYgTFREIiwiTGFzdE5hbWUiOiJTUkYiLCJFbWFpbEFkZHJlc3MiOiJzcmZsdGRAZ21haWwuY29tIiwiUm9sZUlkIjoiMTEiLCJJc0FjdGl2ZSI6IkFjdGl2ZSIsImV4cCI6MTYwOTI0MDk3MCwiaXNzIjoiVmluZXNoU2VydmVyIiwiYXVkIjoiVmluZXNoUG9zdG1hbkNsaWVudCJ9.OM_d5Ydc2JlZTdUNA-JHOAqustQ_SiOLdzXRMkSOqvs");
			localStorage.setItem("User_Id",JSON.stringify("4100002265"));*/
    var auth = localStorage.getItem("auth");
    if (localStorage.getItem("auth") != null) {
      this.isLoading = true;
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var self = this;
      var requestInfo = {
        User_Id: Session_User_Id,
        Token: token,
        Session_User_Id: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "ManageUsers/ViewUserProfile",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((result) => {
          this.isLoading = false;
          if (result.data.status_code == 200) {
            this.$router.push({ name: "Dashboard" });
          } else {
            localStorage.clear();
            this.$router.push("/");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          localStorage.clear();
          this.$router.push("/");
        });
    }
  },
  methods: {
    viewMenu() {
      this.$router.push({ path: "register" });
    },
    viewForgot() {
      this.$router.push({ path: "forgotpassword" });
    },
    viewMenuDash() {
      this.isLoading = true;
      var userId = $("input[name=userId]").val();
      var password = $("input[name=password]").val();
      var req = { User_Id: userId, password: password };

      //localStorage.setItem("auth",'123456');
      //this.$router.push({name:'Dashboard'})
      //var axios = require('axios');
      var data = JSON.stringify(req);
      var self = this;
      var config = {
        method: "post",
        url: apiURL + "Authentication/UserLogin",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then((result) => {
          //console.log(result);
          this.isLoading = false;
          if (result.data.status_code == 200) {
            localStorage.setItem("auth", result.data.response[0].Token);
            // result.data.response[0].UserEmail=result.data.response[0].UserEMail;
            localStorage.setItem("user", JSON.stringify(result.data.response));
            localStorage.setItem(
              "RoleWiseModules",
              JSON.stringify(result.data.RoleWiseModules)
            );
            localStorage.setItem(
              "User_Id",
              JSON.stringify(result.data.response[0].User_Id)
            );
            localStorage.setItem(
              "app_roleId",
              JSON.stringify(result.data.response[0].Role_Id)
            );
            var auth = localStorage.getItem("auth");
            if (localStorage.getItem("auth") != null) {
              if (result.data.response[0].Role_Id == "2") {
                self.$router.push({ name: "Dashboard" });
              } else {
                self.$router.push({ name: "LogoDashboard" });
              }
            }
          } else {
            //$('#reponse_error').html(result.data.message);
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //console.log(error);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
  },
};
</script>
